import {call, put, takeEvery, select} from 'redux-saga/effects';
import {Actions, ACTION_TYPES} from './types';
import {ACTION_TYPES as COURSE_ACTION_TYPES} from '../course/types';
import {ACTION_TYPES as ORGANISATION_ACTION_TYPES} from '../organisation/types';
import GroupsService from '../../services/groups';
import {AddGroupUserArgs, CreateGroupArgs, EditGroupArgs} from '../../common/group';
import {Course} from '../../common/course';
import { selectUserOrganisation } from '../user/selectors';


export function* fetchGroups(): Object {
    try {
        const result = yield call(
            GroupsService.getGroups.bind(GroupsService),
        );
        yield put({
            type: ACTION_TYPES.FETCH_GROUPS_SUCCESS,
            payload: result,
        });
    } catch (err) {
       console.log(err);
    }
    return null;
}

export function* addGroup(action: Actions): Object {
    try {
        const data = action.payload as CreateGroupArgs;
        yield call(
            GroupsService.addGroup.bind(GroupsService),
            data,
        )
        yield put({
            type: ACTION_TYPES.FETCH_GROUPS,
        })
    } catch(error) {
        console.log(error);
    }
    return null;
}

export function* deleteGroup(action: Actions): Object {
    try {
        const groupId = action.payload;
        yield call(
            GroupsService.deleteGroup.bind(GroupsService),
            groupId,
        )
        yield put({
            type: ACTION_TYPES.FETCH_GROUPS,
        })
    } catch(error) {
        console.log(error);
    }
    return null; 
}

export function* editGroup(action: Actions): Object {
    try {
        const data = action.payload as EditGroupArgs;
        yield call(
            GroupsService.editGroup.bind(GroupsService),
            data,
        )
        yield put({
            type: ACTION_TYPES.FETCH_GROUPS,
        })
    } catch(error) {
        console.log(error);
    }
    return null; 
}

export function* addGroupUser(action: Actions): Object {
    try {
        const data = action.payload as AddGroupUserArgs;
        yield call(
            GroupsService.addGroupUser.bind(GroupsService),
            data,
        )
        const organisation = yield select(selectUserOrganisation);
        yield put({
            type: ORGANISATION_ACTION_TYPES.GET_ORGANISATION_PROFILES,
            payload: organisation.alias
        })
    } catch(error) {
        console.log(error);
    }
    return null; 
}

export function* deleteGroupUser(action: Actions): Object {
    try {
        const data = action.payload as AddGroupUserArgs;
        yield call(
            GroupsService.deleteGroupUser.bind(GroupsService),
            data,
        )
        const organisation = yield select(selectUserOrganisation);
        yield put({
            type: ORGANISATION_ACTION_TYPES.GET_ORGANISATION_PROFILES,
            payload: organisation.alias
        })
    } catch(error) {
        console.log(error);
    }
    return null; 
}

export function* getGroupCourses(action: Actions): Object {
    try {
        const groupId = action.payload;
        const result = yield call(
            GroupsService.getGroupCourses.bind(GroupsService),
            groupId,
        )
        yield put({
            type: COURSE_ACTION_TYPES.LOAD_COURSES_SUCCESS,
            payload: result,
        });
        return yield put({
            type: ACTION_TYPES.GET_GROUP_COURSES_SUCCESS,
            payload: {
                groupId,
                courses: result.map((course: Course) => course.id)
            },
        })
    } catch (err) {
        console.log(err);
    }
}

export function* addGroupCourse(action: Actions): Object {
    try {
        const {id, courseId} = action.payload;
        yield call(
            GroupsService.addGroupCourse.bind(GroupsService),
            {id, courseId}
        )
        yield put({
            type: ACTION_TYPES.GET_GROUP_COURSES,
            payload: id,
        })
    } catch (err) {
        console.log(err);
    }
}

export function* deleteGroupCourse(action: Actions): Object {
    try {
        const {id, courseId} = action.payload;
        yield call(
            GroupsService.deleteGroupCourse.bind(GroupsService),
            {id, courseId}
        )
        yield put({
            type: ACTION_TYPES.GET_GROUP_COURSES,
            payload: id,
        })
    } catch (err) {
        console.log(err);
    }
}

const groupSaga = [
    takeEvery(ACTION_TYPES.FETCH_GROUPS, fetchGroups),
    takeEvery(ACTION_TYPES.ADD_GROUP, addGroup),
    takeEvery(ACTION_TYPES.DELETE_GROUP, deleteGroup),
    takeEvery(ACTION_TYPES.EDIT_GROUP, editGroup),
    takeEvery(ACTION_TYPES.ADD_GROUP_USER, addGroupUser),
    takeEvery(ACTION_TYPES.DELETE_GROUP_USER, deleteGroupUser),
    takeEvery(ACTION_TYPES.GET_GROUP_COURSES, getGroupCourses),
    takeEvery(ACTION_TYPES.ADD_GROUP_COURSE, addGroupCourse),
    takeEvery(ACTION_TYPES.DELETE_GROUP_COURSE, deleteGroupCourse),
];

export default groupSaga;
